import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Typography, Box, Paper, Button, Stack, Divider, Chip, List, ListItem, ListItemText } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { formatPrice } from '../utils/currency';

function OrderSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const fallbackMeta = React.useMemo(() => {
    try {
      const legacyOrderKey = ['f', 'u', 's', 'i', 'o', 'n', 'L', 'a', 's', 't', 'O', 'r', 'd', 'e', 'r'].join('');
      return JSON.parse(localStorage.getItem('fastxhorizonLastOrder') || localStorage.getItem(legacyOrderKey)) || null;
    } catch (error) {
      return null;
    }
  }, []);
  const stateMeta = location.state || {};
  const orderNumber = stateMeta.orderNumber || fallbackMeta?.orderNumber;
  const email = stateMeta.email || fallbackMeta?.email;
  const items = Array.isArray(stateMeta.items) ? stateMeta.items : [];
  const total = typeof stateMeta.total === 'number' ? stateMeta.total : null;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6, mb: 10 }}>
      <Paper elevation={0} sx={{ p: { xs: 4, md: 6 }, textAlign: 'center', borderRadius: 4, maxWidth: 640 }}>
        <CheckCircleOutlineIcon sx={{ fontSize: 72, color: 'success.main', mb: 2 }} />
        <Typography variant="h4" gutterBottom fontWeight={700}>Order Successful!</Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Thank you for your purchase. Your order has been received and the next status updates will be shared through your account.
        </Typography>

        {orderNumber && (
          <Stack spacing={1.5} alignItems="center" sx={{ mb: 4 }}>
            <Chip label={`Order #: ${orderNumber}`} color="primary" variant="outlined" />
            {email && <Typography variant="caption" color="text.secondary">Confirmation sent to {email}</Typography>}
          </Stack>
        )}

        {items.length > 0 && (
          <Box sx={{ textAlign: 'left', mb: 4 }}>
            <Typography variant="subtitle1" fontWeight={600} gutterBottom>Items in this order</Typography>
            <List dense>
              {items.map(item => <ListItem key={`${item.productId}-${item.name}`} disableGutters sx={{ py: 0.5 }}><ListItemText primary={item.name} secondary={`Qty ${item.quantity} • ${formatPrice(item.price || 0)}`} /></ListItem>)}
            </List>
            {typeof total === 'number' && <Divider sx={{ my: 2 }} />}
            {typeof total === 'number' && <Typography variant="subtitle2" fontWeight={600}>Order total: {formatPrice(total)}</Typography>}
          </Box>
        )}

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
          <Button variant="contained" endIcon={<ArrowForwardIcon />} onClick={() => navigate('/shop')}>Continue shopping</Button>
          <Button variant="outlined" color="secondary" onClick={() => navigate('/support')}>Need support?</Button>
        </Stack>
      </Paper>
    </Box>
  );
}

export default OrderSuccess;
